<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label>
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <BuscarSelecionar
      :id="id"
      :lista="usuarios"
      :selecionado="usuario"
      :minimo="minimo"
      :exibir="['name', 'email']"
      :exibir-chave="false"
      @selecionar="selecionar"
      @limpar="limpar"
      @recuperar="recuperar"
    />
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import UsuarioServico from '@/servicos/UsuarioServico'

const usuarioServico = new UsuarioServico()

export default {
  name: 'BuscarSelecionarUsuario',
  components: { BuscarSelecionar },
  props: {
    label: {
      type: String,
      default: 'Usuário',
    },
    labelSup: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'usuario',
    },
    minimo: {
      type: Number,
      default: 0,
    },
    validacao: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      usuario: {},
      usuarios: [],
    }
  },
  methods: {
    selecionar(usuario) {
      this.$emit('selecionadoUsuario', usuario)
    },
    limpar() {
      this.usuario = {}
    },
    recuperar(filtro) {
      const data = {
        name: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
        ativo: true,
      }
      usuarioServico.recuperarTodos(data).then((result) => {
        this.usuarios = result.usuarios
      })
    },
  },
}
</script>
